import { coreDataStore, getClientPlayer } from "../../helper/CoreDataStorage";
import { audio_engine } from "../core/AudioEngine";
import { setOrientation } from "../effects/Orientation";
import { refreshRegionMusic } from "../utils/AudioManager";

export class OnrideMusic {
  private sound: Howl;
  private id: number;

  constructor(src: string) {
    this.id = Date.now();
    this.sound = new Howl({
      src: [src],
      autoplay: true,
      html5: false,
      loop: false,
      volume: audio_engine.music_volume,
      onend: () => {
        audio_engine.onride_sound = null;
        refreshRegionMusic();
      },
    });

    audio_engine.onride_sound = this;
  }

  updateVolume() {
    this.sound.volume(audio_engine.music_volume);
  }

  stop() {
    this.sound.stop();
  }
}
